$(document).ready(function () {
    let offset = ((window.innerWidth - 1140) / 2);
    if (offset < 0) {
        offset = 0;
    }

    let brandsSwiper = new Swiper("#ourBrands", {
        slidesPerView: "auto",
        grabCursor: true,
        slidesOffsetAfter: offset,
        slidesOffsetBefore: offset,
        pagination: {
            el: "#ourBrands .swiper-pagination",
            clickable: true,
        },
    });

    window.addEventListener("resize", function () {
        let offset = ((window.innerWidth - 1140) / 2);
        if (offset < 0) {
            offset = 0;
        }

        brandsSwiper.params.slidesOffsetBefore = offset;
        brandsSwiper.params.slidesOffsetAfter = offset;
        brandsSwiper.update();
    });

});
